import { Component, computed, Input, input, InputSignal, OnInit, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import { CommonModule, DatePipe } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import { AccordionGroupComponent } from '../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../common/accordion-item/accordion-item.component';
import {
  ApplicantItemPreviewComponent
} from '../../common/applicant-data-section/components/applicant-item-preview/applicant-item-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { EntityLabelPipe } from '../../../../../pipes/applicant-label.pipe';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';
import {
  NotificationOfEmergencyOccupationFormValue,
  occupationsToFormValue
} from '../sections/notification-of-emergency-occupation-data-section/forms/notification-of-emergency-occupation.form';
import {
  NotificationOfEmergencyOccupationPreviewComponent
} from '../sections/notification-of-emergency-occupation-data-section/components/notification-of-emergency-occupation-preview/notification-of-emergency-occupation-preview.component';

@Component({
  selector: 'app-notification-of-emergency-preview',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    LabelComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    ApplicantItemPreviewComponent,
    ApplicationDataPreviewComponent,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    EntityLabelPipe,
    ApplicantPreviewComponent,
    DecisionDataPreviewComponent,
    ContractorDataPreviewComponent,
    NotificationOfEmergencyOccupationPreviewComponent
  ],
  templateUrl: './notification-of-emergency-preview.component.html'
})
export class NotificationOfEmergencyPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public roadOccupations: Signal<NotificationOfEmergencyOccupationFormValue[]> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []));

  constructor() {
  }

  public ngOnInit(): void {
  }
}
